import React, { HTMLProps, memo } from "react";
import classnames from "classnames";
import { SIZE } from "../base";
import Button from "../button";
import Icon from "../icon";

export enum BUTTON_TYPE {
    NORMAL = "",
    OUTLINE = "is-outlined",
}

interface IProps extends HTMLProps<HTMLButtonElement> {
    className?: string;
    classNameIcon?: string;
    onClick?: (evt: any) => any;
    title?: string;
    text?: string;
    icon?: string | React.ReactNode;
    isSize?: SIZE;
    type?: BUTTON_TYPE;
    radius?: number;
    isActive?: boolean;
    uppered?: boolean;
    fullwidth?: boolean;
    outlined?: boolean;
    disabled?: boolean;
    triggerBefore?: React.ReactNode;
    loading?: boolean;
    renderAs?: string;
}

export const IconButton = React.forwardRef((props: IProps, ref) => {
    const {
        title,
        text,
        className = "",
        classNameIcon = "",
        onClick,
        icon,
        type = BUTTON_TYPE.NORMAL,
        isSize,
        isActive = false,
        uppered = false,
        fullwidth = false,
        disabled = false,
        triggerBefore = null,
        loading,
        renderAs,
        outlined,
        style,
        color
    } = props;

    return (
        <Button
            type="button"
            domRef={ref}
            onClick={onClick}
            className={classnames(className, type, {
                active: isActive,
            })}
            disabled={disabled}
            uppered={uppered}
            fullwidth={fullwidth}
            isSize={isSize}
            loading={loading}
            outlined={outlined}
            renderAs={renderAs}
            title={title}
            style={style}
            color={color}
            aria-label="Button"
        >
            <Icon className={classNameIcon} icon={icon} />
            {text ? <span>{text}</span> : null}
            {triggerBefore}
        </Button>
    );
});

export default memo(IconButton);
